// @flow
import React, { useCallback, useState, Fragment } from 'react';

import ReportSectionCSS from 'app/components/common/reports/ReportSectionCSS';
import Loader from 'app/common/components/Loader';
import EmptyWarn from 'app/common/layouts/EmptyWarn';
import { RowLayoutContent } from 'app/common/layouts/RowLayout';
import { useCurrencySign } from 'app/common/components-next/currency';
import detailsFilter from 'app/components/common/reports/filters/details';
import { useFilterApplied } from 'app/common/ui-components/filter';
import DetailsHeader from 'app/components/common/reports/DetailsHeader';
import HistoryLink, { reportTypes } from 'app/components/common/reports/history/HistoryLink';
import EmptyReportCSS from 'app/components/common/reports/EmptyReportCSS';

import useReportData from './useReportData';
import HeaderBar from './HeaderBar';
import Summary from './Summary';
import DetailsSolo from './DetailsSolo';
import DetailsMultiple from './DetailsMultiple';


const empty = {};

type Props = {
  reportId: number | null,
}

const Report = ({ reportId }: Props) => {
  const currencySign = useCurrencySign();

  const [fs, changeFullScreen] = useState(false);
  const toggleFS = useCallback((e: SyntheticEvent<HTMLElement>) => {
    e.preventDefault();
    changeFullScreen(fullscreen => !fullscreen);
  }, []);

  const [data, loading] = useReportData(reportId);
  const { summary, multiple, payments } = data || empty;

  const detailsChecked = Boolean(useFilterApplied(detailsFilter, 0));

  const hasSummary = !!summary;
  const hasDetailsMultiple = !!multiple;
  const hasDetailsSolo = !!payments;
  const hasDetails = hasDetailsMultiple || hasDetailsSolo;
  const emptyMessage = detailsChecked ? !hasDetails : !hasSummary;

  if (!reportId) {
    return (
      <EmptyReportCSS
        stickyNumber={2}
        headerBar={
          <HistoryLink reportType={reportTypes.REPORT_FINANCES_BY_SELL_TYPE} />
        }
      />
    );
  }

  return (
    <ReportSectionCSS
      stickyNumber={2}
      header="Отчет «Касса в столовой»"
      headerBar={
        <HeaderBar
          onFullscreen={toggleFS}
          reportId={reportId}
        />
      }
      fullscreen={fs}
      wideContent
    >
      {loading
        ? <Loader />

        : <Fragment>
          {summary
            && <Summary
              loading={loading}
              summary={summary}
              currencySign={currencySign}
            />}

          {detailsChecked
            && <DetailsHeader reportTitle="Касса в столовой" />}

          {payments
            && <DetailsSolo payments={payments} />}

          {multiple
            && <DetailsMultiple multiple={multiple} />}

          {emptyMessage
            && <RowLayoutContent borderTop paddingfree>
              <EmptyWarn>
                {'Данные отсутствуют'}
              </EmptyWarn>
            </RowLayoutContent>}

        </Fragment>}
    </ReportSectionCSS>
  );
};

export default Report;
